import { FilterMatchMode } from 'primereact/api';

export const tableFilters = {
  id_cabezal: { value: null, matchMode: FilterMatchMode.CONTAINS },
  fecDoc: { value: null, matchMode: FilterMatchMode.DATE_IS },
  fecVenc: { value: null, matchMode: FilterMatchMode.DATE_IS },
  nombreDocumento: { value: null, matchMode: FilterMatchMode.CONTAINS },
  nroDoca: { value: null, matchMode: FilterMatchMode.CONTAINS },
  armador: { value: null, matchMode: FilterMatchMode.CONTAINS },
  contenedor: { value: null, matchMode: FilterMatchMode.CONTAINS },
  antiguedad: { value: null, matchMode: FilterMatchMode.CONTAINS },
  viajeBuque: { value: null, matchMode: FilterMatchMode.CONTAINS },
  seleccion: { value: null, matchMode: FilterMatchMode.CONTAINS },
  referencia: { value: null, matchMode: FilterMatchMode.CONTAINS },
  referenciaLiquidacion: { value: null, matchMode: FilterMatchMode.CONTAINS },
  razonSocial: { value: null, matchMode: FilterMatchMode.CONTAINS },
  impMovMo: { value: null, matchMode: FilterMatchMode.CONTAINS },
};
